/**
 * form-kit.js — Steuerung des gemeinsamen Erfolgs-Overlays (Uhrinstinkt)
 *
 * Wird von allen Formularen genutzt (Ankauf, Kontakt, Widerruf).
 * - openOverlay(id, referenceValue): Overlay einblenden, Fokus, Scroll-Lock
 * - closeOverlay(el): Overlay schliessen, Fokus zurueck
 * - Schliessen via Button [data-fk-close], Klick auf Backdrop oder ESC
 * - Beim Laden bereits offene Overlays (z. B. Shopify-Reload) werden initialisiert.
 */
(function () {
  'use strict';

  var lastTrigger = null;

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openOverlay(id, referenceValue) {
    var el = document.getElementById(id);
    if (!el) return;
    activate(el, referenceValue);
  }

  function activate(el, referenceValue) {
    lastTrigger = document.activeElement;

    // Referenz-/Ticket-Nr. (optional)
    var ref = el.querySelector('.fk-overlay__ref');
    if (ref && referenceValue) {
      var prefix = ref.getAttribute('data-ref-prefix') || '';
      ref.textContent = (prefix ? prefix + ' ' : '') + referenceValue;
      ref.hidden = false;
    }

    el.hidden = false;
    lockScroll(true);

    var heading = el.querySelector('.fk-overlay__heading');
    if (heading) heading.focus();
  }

  function closeOverlay(el) {
    if (!el) return;
    el.hidden = true;
    lockScroll(false);
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  // ---- Globale Event-Bindings ----
  document.addEventListener('click', function (evt) {
    var closer = evt.target.closest('[data-fk-close]');
    if (closer) {
      closeOverlay(closer.closest('.fk-overlay'));
      return;
    }
    // Klick auf Backdrop (Overlay-Wrapper selbst, nicht die Karte)
    if (evt.target.classList && evt.target.classList.contains('fk-overlay')) {
      closeOverlay(evt.target);
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var open = document.querySelector('.fk-overlay:not([hidden])');
    if (open) closeOverlay(open);
  });

  // Beim Laden bereits offene Overlays (Shopify-Reload nach erfolgreichem POST)
  document.addEventListener('DOMContentLoaded', function () {
    var open = document.querySelector('.fk-overlay:not([hidden])');
    if (!open) return;

    // Signatur dieses Erfolgs (ID + Query, Pfad bewusst weggelassen, damit ein
    // Sprachwechsel mit gleichem Erfolgs-Parameter NICHT erneut auslöst).
    var sig = open.id + '|' + window.location.search;
    var seen = null;
    try { seen = window.sessionStorage.getItem('fk-success-seen'); } catch (e) {}

    if (seen === sig) {
      // Reload/Sprachwechsel derselben Erfolgsseite -> nicht erneut anzeigen
      open.hidden = true;
      return;
    }

    try { window.sessionStorage.setItem('fk-success-seen', sig); } catch (e) {}

    lockScroll(true);
    var heading = open.querySelector('.fk-overlay__heading');
    if (heading) heading.focus();

    // URL bereinigen, damit ein simpler Reload den Erfolg nicht erneut rendert
    if (window.location.search && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  });

  window.FormKit = {
    openOverlay: openOverlay,
    closeOverlay: closeOverlay
  };
})();
